const fv_slider = new Swiper(".p_home_mv", {
  slidesPerView: 1,
  loop: true,
  centeredSlides: true,
  spaceBetween: 0,
  autoplay: {
    delay: 4000,
  },
  speed: 500,
  loopAdditionalSlides: 3,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    768: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
  },
});
const fv_newsSlider = new Swiper(".p_newsWrap", {
  slidesPerView: 1,
  loop: true,
  centeredSlides: false,
  spaceBetween: 0,
  autoplay: {
    delay: 5000,
  },
  speed: 1000,
  loopAdditionalSlides: 3,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
  },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    768: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
  },
});
// const item_slider = new Swiper(".b_itemSlider", {
//   slidesPerView: 2,
//   loop: true,
//   centeredSlides: false,
//   spaceBetween: 7,
//   speed: 500,
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   pagination: {
//     el: ".swiper-pagination",
//     type: 'progressbar',
//     clickable: true,
//   },
//   breakpoints: {
//     1200: {
//       slidesPerView: 4,
//       spaceBetween: 7,
//     },
//     768: {
//       slidesPerView: 4,
//       spaceBetween: 7,
//     },
//   },
// });
// if (window.matchMedia('(min-width: 767px)').matches) {
// const product_slider = new Swiper(".p_productsSlider", {
//   slidesPerView: 2,
//   loop: false,
//   centeredSlides: false,
//   spaceBetween: 7,
//   speed: 500,
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   pagination: {
//     el: ".swiper-pagination",
//     type: 'progressbar',
//     clickable: true,
//   },
//   breakpoints: {
//     1200: {
//       slidesPerView: 3.2,
//       spaceBetween: 7,
//     },
//     768: {
//       slidesPerView: 3.2,
//       spaceBetween: 7,
//     },
//   },
// });
// }
if (window.matchMedia("(max-width: 767px)").matches) {
  const item_slider = new Swiper(".p_item_list", {
    slidesPerView: 2,
    loop: true,
    centeredSlides: false,
    spaceBetween: 20,
    speed: 500,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".js-element-fast").forEach((target) => {
  gsap.fromTo(
    target,
    {
      y: -10,
      opacity: 0,
    },
    {
      scrollTrigger: {
        trigger: target,
        markers: false,
        start: "-120% center",
      },
      y: 0,
      opacity: 1,
      duration: 1,
    }
  );
});
gsap.utils.toArray(".js-element").forEach((target) => {
  gsap.fromTo(
    target,
    {
      y: 20,
      opacity: 0,
    },
    {
      scrollTrigger: {
        trigger: target,
        markers: false,
        start: "-50% center",
      },
      y: 0,
      opacity: 1,
      duration: 1,
    }
  );
});
gsap.utils.toArray(".js-element-right").forEach((target) => {
  gsap.fromTo(
    target,
    {
      x: 20,
      opacity: 0,
    },
    {
      scrollTrigger: {
        trigger: target,
        markers: false,
        start: "-30% center",
      },
      x: 0,
      opacity: 1,
      duration: 1,
    }
  );
});
gsap.utils.toArray(".js-element-left").forEach((target) => {
  gsap.fromTo(
    target,
    {
      x: -20,
      opacity: 0,
    },
    {
      scrollTrigger: {
        trigger: target,
        markers: false,
        start: "-30% center",
      },
      x: 0,
      opacity: 1,
      duration: 1,
    }
  );
});

window.addEventListener("scroll", function () {
  const header = document.querySelector(".l_header");
  const fv = document.querySelector(".js-fv");
  if (window.scrollY > fv.offsetHeight) {
    header.classList.add("is-active");
  } else {
    header.classList.remove("is-active");
  }
});

let moreBtn = document.querySelector(".p_aboutTxtBox_icon");
let aboutTxt = document.querySelector(".p_aboutTxtBox");
moreBtn.addEventListener("click", function () {
  moreBtn.classList.toggle("is-hidden");
  if (moreBtn.classList.contains("is-hidden")) {
    aboutTxt.classList.add("is-active");
  } else {
    moreBtn.classList.remove("is-hidden");
  }
});
